/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import BaseEditor, { FieldName } from 'cio/components/action-composer/base-glimmer/editor';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import { scheduleOnce } from '@ember/runloop';
import { isNone } from '@ember/utils';
import EnvironmentService from 'cio/services/environment';
import IdentityModel from 'cio/models/identity';
import MasqService from 'cio/services/masq';
import { getLiquidToInsert } from 'cio/utils/liquid';

const MMS_MESSAGE_IMAGE_BYTES_LIMIT = 600 * 1024; // 600KB

export default class TwilioEditor extends BaseEditor {
  @service environment!: EnvironmentService;
  @service store!: DS.Store;
  @service masq!: MasqService;

  imageSizeLimitInBytes = MMS_MESSAGE_IMAGE_BYTES_LIMIT;

  readonly defaultRecipient = '{{customer.phone}}';
  readonly editorClassNames = {
    'template.to': 'js-editor-to',
    'template.body': 'js-editor-textarea',
    'template.imageUrl': 'js-editor-image-url',
  };

  get identityOptions() {
    return this.environment.current.identities
      .filterBy('templateType', 'twilio')
      .map((identity) => ({ value: identity.id, label: identity.nameAndPhone }));
  }

  @action
  onSelectIdentity(value: any) {
    let { template } = this.args.editableEntity;
    if (template != null) {
      template.fromIdentity = this.environment.current.identities.find(
        (identity) => identity.id === value.value,
      ) as IdentityModel;
    }
  }

  @action
  insertLiquid([fieldName]: [FieldName, number], liquid: string, fallback?: string) {
    let className = this.editorClassNames[fieldName];
    if (!className) {
      return;
    }

    let input = document.querySelector(`.${className}`) as HTMLInputElement | HTMLTextAreaElement;
    if (isNone(input.selectionStart) || isNone(input.selectionEnd)) {
      return;
    }

    let { value, selectionStart, selectionEnd } = input;
    let beginStr = value.substr(0, selectionStart);
    let endStr = value.substr(selectionEnd, value.length);
    let liquidToInsert = getLiquidToInsert(liquid, fallback, this.args.editableEntity.template?.templateEngine);

    input.value = `${beginStr}${liquidToInsert}${endStr}`;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  @action
  changeRecipient() {
    this.args.editableEntity.template?.set('recipient', '');

    scheduleOnce('afterRender', this, () => {
      (document.querySelector('.js-editor-field-to .fly-form-control') as HTMLInputElement)?.focus();
    });
  }

  @action
  useDefaultRecipient() {
    this.args.editableEntity.template?.set('recipient', null);
  }

  @action
  onImageFileUrlChange(imageUrl: string) {
    let { template } = this.args.editableEntity;
    if (template != null) {
      template.imageUrl = imageUrl;
    }
  }
}
